export class GetMicrosoft365BackupScopeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "config",
            "baseName": "config",
            "type": "Microsoft365PolicyConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetMicrosoft365BackupScopeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
